<script setup>
import { computed, defineProps, defineEmits, ref } from 'vue';

const props = defineProps({
  step: {
    type: Number,
    required: true
  },
  // Which role each tab applies to, keyed by step -- the Role Selection tab
  // (step 1) is always shown, since a role must be picked before any other
  // tab is relevant.
  tabsMeta: {
    type: Array,
    required: true
  },
  currentRoleId: {
    type: String,
    default: null
  },
  t: {
    type: Function,
    required: true
  },
  i18nScope: {
    type: String,
    required: true
  }
});

defineEmits(['tab-click']);

const tabs = ref([
  { name: 'Role Selection', step: 1 },
  { name: 'Network Selection', step: 2 },
  { name: 'Library Selection', step: 3 },
  { name: 'Retailer Selection', step: 4 },
  { name: 'Identity', step: 5 },
  { name: 'Summary', step: 6 }
])

const tabName = (tab) => {
  return tab.name.toLowerCase().replace(' ', '_');
}

const isVisible = (tab) => {
  if (tab.step === 1) return true;

  const meta = props.tabsMeta.find(m => m.step === tab.step);
  return meta ? meta.rolesAllowed.includes(props.currentRoleId) : true;
}

const visibleTabs = computed(() => tabs.value.filter(isVisible));
</script>
<template>
  <ul class="nav nav-tabs" id="myTab" role="tablist">
    <li v-for="tab in visibleTabs" :key="tab.step" class="nav-item" role="presentation">
      <button
      class="nav-link"
      :class="{ active: step === tab.step, disabled: step !== tab.step }"
      :id="`${tabName(tab)}-tab`"
      data-bs-toggle="tab"
      :data-bs-target="`#${tabName(tab)}_page`"
      type="button"
      role="tab"
      :aria-controls="`${tabName(tab)}_page`"
      :aria-selected="step === tab.step ? 'true' : 'false'"
      @click="$emit('tab-click', tab.step)"
      >
      {{ t(`${i18nScope}.user_details.tab_${tabName(tab)}`) }}
      </button>
    </li>
  </ul>
</template>